/**
 * Supabase Client
 * 
 * Singleton instance of Supabase client for database access.
 * Configured with environment variables.
 * 
 * Usage:
 *   import { supabase } from './services/supabaseClient.js';
 *   
 *   const { data, error } = await supabase
 *     .from('car_listings')
 *     .select('*');
 */

import { createClient } from '@supabase/supabase-js';

// Supabase configuration from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

// Create Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Export as default for flexibility
export default supabase;
